import * as React from 'react';
import { Field } from 'react-unity';
import { Grid } from '../../common/layouts/Grid';
import { Button } from '../../common/components/Button';
import { Alert } from '../../common/components/Alert';
import StandardModal from '../../common/modals/StandardModal';
import ReadOnlyField from '../../common/form-controls/ReadOnly';

interface TAPModalProps {
  visible: boolean,
  setVisible:any
  tap: string;
}

const TAPModal = ({visible, setVisible, tap}:TAPModalProps) => {
    

    return (
      <StandardModal
        show={visible}
        onDismiss={() => setVisible(false)}
        title="TAP Request"
        optionalClass="em-u-margin-double"
        footer={
          <Grid variant="2up">
            <Grid.Item style={{display: 'flex', justifyContent: 'center', textAlign: 'center'}}>
              <Button
                variant="secondary"
                onClick={() => setVisible(false)}
              >
                Close
              </Button>
            </Grid.Item>
          </Grid>
        }
      >
        <Field>
          <Field.Body>
            <ReadOnlyField label="Temporary Access Password" text={tap} copy={true}/>
          </Field.Body>
        </Field>
        <Alert
          variant='warning'
          body="Please keep track of this passcode. The passcode is valid for 60 minutes and you cannot generate another passcode until the current passcode expires."
        />
      </StandardModal>
    );
}

export default TAPModal;
